import gql from 'graphql-tag'
import { CONFIG } from '../config'
import { IShopifyCheckoutInput, IShopifyCheckoutResponse, IShopifyNode, IShopifyCheckoutNode } from '../interfaces'
import { HTTPService } from './http.service'

class ShopifyStorefrontService extends HTTPService {
  private endpoint: string = CONFIG.shopify.graphqlApiEndpoint

  async getCheckout(id: string): Promise<IShopifyNode<IShopifyCheckoutNode>> {
    try {
      return await this.graphql(
        this.endpoint,
        { id },
        gql`
          query node($id: ID!) {
            node(id: $id) {
              ... on Checkout {
                completedAt
              }
            }
          }
        `
      )
    } catch (e) {
      return null
    }
  }
}

export const shopifyStorefrontService = new ShopifyStorefrontService({
  'X-Shopify-Storefront-Access-Token': CONFIG.shopify.storefrontAccessToken
})
